import { useMemo } from 'react';
import useSelector from './useSelector';

export default function () {
  const { decodedToken } = useSelector((state) => state.user);
  return useMemo(() => decodedToken && decodedToken.account_owner_id === decodedToken.user_id, [decodedToken]);
}
